import { collections } from "@/mocks/home";

export default function Collections() {
  const [featured, ...rest] = collections;

  return (
    <section id="collection" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
              <i className="ri-folders-line" aria-hidden="true" />按系列归档
            </span>
            <h2 className="mt-4 text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">最新合集</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              把散落的新内容按系列归整成长期合集。追更的人不需要每次重新找，收藏一份即可反复翻。
            </p>
          </div>
          <a href="#collection" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-600 hover:text-accent-700">
            全部合集 <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>

        {/* 大卡 + 小卡混排 */}
        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-3">
          {/* 大卡 */}
          <a href="#cta" className="group relative overflow-hidden rounded-xl bg-foreground-900 lg:col-span-2 lg:row-span-2">
            <img
              src={featured.cover}
              alt="福利岛影视动画新番速报总合集"
              className="absolute inset-0 h-full w-full object-cover opacity-40 transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
            <div className="relative flex h-full min-h-[320px] flex-col justify-end p-6 md:p-8">
              <span className="inline-flex w-fit items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs text-background-50">
                <i className="ri-fire-fill" aria-hidden="true" />本站热门
              </span>
              <h3 className="mt-3 text-xl font-bold text-background-50 md:text-2xl">{featured.title}</h3>
              <p className="mt-2 max-w-lg text-sm leading-relaxed text-background-50/80">{featured.desc}</p>
              <div className="mt-4 flex flex-wrap items-center gap-3 text-xs text-background-50/80">
                <span className="flex items-center gap-1"><i className="ri-folder-2-line" aria-hidden="true" />{featured.items}</span>
                <span className="flex items-center gap-1"><i className="ri-time-line" aria-hidden="true" />{featured.update}</span>
                <span className="flex items-center gap-1"><i className="ri-fire-line" aria-hidden="true" />{featured.heat}</span>
              </div>
            </div>
          </a>

          {/* 小卡 */}
          {rest.map((c) => (
            <a href="#cta" key={c.title} className="group flex flex-col rounded-xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200">
              <div className="relative h-36 overflow-hidden rounded-lg">
                <img
                  src={c.cover}
                  alt={`福利岛${c.title}最新合集`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded bg-background-50/90 px-2 py-0.5 text-[11px] font-medium text-primary-600">{c.tag}</span>
              </div>
              <div className="flex flex-1 flex-col px-1 py-3">
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-700 md:text-base">{c.title}</h3>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">{c.desc}</p>
                <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3 text-[11px] text-foreground-400">
                  <span>{c.items}</span>
                  <span className="text-accent-600">{c.heat}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}